import { useQuery } from "react-query";
import { getNewHireFranchiseEmployeeCount } from "../../../../../actions/Employees";

const useGetNewHireFranchiseEmployeeCount = () => {
  return useQuery(
    "GetNewHireFranchiseEmployeeCount",
    getNewHireFranchiseEmployeeCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetNewHireFranchiseEmployeeCount;
